import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Index from './pages/Index';
import Chat from './pages/Chat';
import Auth from './pages/Auth';
import Analyzer from './pages/Analyzer';
import Properties from './pages/Properties';
import Dashboard from './pages/Dashboard';
import DashboardNew from './pages/DashboardNew';
import Favorites from './pages/Favorites';
import TermsAcceptance from './pages/TermsAcceptance';
import Opciones from './pages/Opciones';
import Reports from './pages/Reports';
import GabiPro from './pages/GabiPro';
import { LegalDocumentPage } from './pages/LegalDocumentPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import ContactPage from './pages/ContactPage';
import { ScrollToTop } from './components/ScrollToTop';
import { getClientInfo } from './supabase';

/** /dashboard dinámico según clients.admin (true => nuevo, false => antiguo). */
const DashboardRoute = () => {
  const { user } = useAuth();
  const [loadingDashboard, setLoadingDashboard] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const resolveDashboard = async () => {
      if (!user?.email) {
        if (!cancelled) {
          setIsAdmin(false);
          setLoadingDashboard(false);
        }
        return;
      }

      try {
        setLoadingDashboard(true);
        const client = await getClientInfo(user.email);
        if (cancelled) return;
        setIsAdmin(Boolean(client?.admin));
      } catch (_) {
        if (!cancelled) {
          setIsAdmin(false);
        }
      } finally {
        if (!cancelled) {
          setLoadingDashboard(false);
        }
      }
    };

    resolveDashboard();
    return () => {
      cancelled = true;
    };
  }, [user?.email]);

  if (loadingDashboard) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
      </div>
    );
  }

  return isAdmin ? <DashboardNew /> : <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/privacidad" element={<LegalDocumentPage routeKey="privacidad" />} />
          <Route path="/terminos" element={<LegalDocumentPage routeKey="terminos" />} />
          <Route path="/cookies" element={<LegalDocumentPage routeKey="cookies" />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route
            path="/terms"
            element={
              <ProtectedRoute>
                <TermsAcceptance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analyzer"
            element={
              <ProtectedRoute>
                <Analyzer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/properties"
            element={
              <ProtectedRoute>
                <Properties />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardRoute />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard-new"
            element={
              <ProtectedRoute>
                <DashboardNew />
              </ProtectedRoute>
            }
          />
          <Route
            path="/favorites"
            element={
              <ProtectedRoute>
                <Favorites />
              </ProtectedRoute>
            }
          />
          <Route
            path="/opciones"
            element={
              <ProtectedRoute>
                <Opciones />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gabi-pro"
            element={
              <ProtectedRoute>
                <GabiPro />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
